<template>
  <div class="custom-actions">
    <button class="ui basic button" @click="modifyAction">
      <i class="edit icon"></i>
    </button>

    <button class="ui basic button" @click="deleteAction">
      <i class="delete icon"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "CartManagementCustomActionComponent",
  props: {
    rowData: {
      type: Object
    }
  },
  methods: {
    modifyAction() {
      this.$modal.changeToComponent(
        this.$modal.modalType.ModifyWpUserState,
        this.rowData
      );
    },
    deleteAction() {
      this.$modal.changeToComponent(
        this.$modal.modalType.DeleteWpUser,
        this.rowData
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-actions button.ui.button {
  padding: 8px 8px;
}

.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/carts-management/custom-action-component/CartManagementCustomActionComponent.vue